import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import Link from '@mui/material/Link';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';

interface HeaderProps {
  title: string;
  description: string;
  view: 'list' | 'grid' | 'detail';
  onViewChange: (event: React.MouseEvent<HTMLElement>, newView: 'list' | 'grid' | null) => void;
  onDescriptionChange: (newDescription: string) => void;
  titleHref?: string; // Optional URL to make title clickable
  disableEditing?: boolean; // Disable editing (e.g., in search mode)
}

const Header = ({ title, description, view, onViewChange, onDescriptionChange, titleHref, disableEditing = false }: HeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        mb: 2,
      }}>
      <Paper
        variant="outlined"
        sx={{
          bgcolor: 'white',
          width: '832px', // 800px + (16px * 2) to account for parent padding
          position: 'relative',
        }}>
        <Box
          sx={{
            bgcolor: 'grey.200',
            px: 2,
            pt: 2,
            pb: 1,
          }}>
          {titleHref ? (
            <Link
              href={titleHref}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontSize: '1.1rem',
                fontWeight: 600,
                color: 'text.primary',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}>
              {title}
            </Link>
          ) : (
            <Typography
              variant="h6"
              sx={{
                fontSize: '1.1rem',
                fontWeight: 600,
                color: 'text.primary',
              }}>
              {title}
            </Typography>
          )}
        </Box>
      </Paper>

      {view !== 'detail' && (
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={onViewChange}
          size="small"
          sx={{
            alignSelf: 'flex-end',
            height: 'fit-content',
            mt: 'auto',
            mb: 0,
          }}>
          <ToggleButton value="list">
            <ViewListIcon />
          </ToggleButton>
          <ToggleButton value="grid">
            <ViewModuleIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      )}
    </Box>
  );
};

export default Header;
